export const RECOURSE = "b8501e65-4683-11e9-82f6-0242ac120002";
export const PARTIAL_RECOURSE = "BF88C781-8158-48C9-B32E-592833771908";
export const NON_RECOURSE = "bc1814ab-4683-11e9-82f6-0242ac120002";

export const recourseTypeList = [
  { name: "Recourse", value: RECOURSE },
  { name: "Partial Recourse", value: PARTIAL_RECOURSE },
  { name: "Non-Recourse", value: NON_RECOURSE }
];
